export const BRAND_BLUE = "#0147C8";

export const REVIEW_REMARK_ISSUE_TAB = "remark-issues";

export const BARCODE_PREFIX_TO_CATEGORY = {
    bldg: "Buildings",
    eqp: "Equipment",
    furn: "Furniture",
    ict: "ICT",
    land: "Land",
    mach: "Machinery",
    site: "Site Works",
    veh: "Vehicles",
    infr: "Infrastructure",
};

export const CATEGORY_CODE_ALIASES = {
    BLDG: "BLDG",
    BUILDING: "BLDG",
    BUILDINGS: "BLDG",
    FURN: "FURN",
    FURNITURE: "FURN",
    "FURNITURE & FITTINGS": "FURN",
    "FURNITURE AND FITTINGS": "FURN",
    ICT: "ICT",
    "ICT EQUIPMENT": "ICT",
    VEH: "VEH",
    VEHICLE: "VEH",
    VEHICLES: "VEH",
    "MOTOR VEHICLE": "VEH",
    "MOTOR VEHICLES": "VEH",
    "MOTOR VEHICLES (INCL. MOTORCYCLES)": "VEH",
    MACH: "MACH",
    MACHINE: "MACH",
    MACHINERY: "MACH",
    "MACHINERY & PLANTS": "MACH",
    "MACHINERY AND PLANTS": "MACH",
    LAND: "LAND",
    EQP: "EQP",
    EQUIPMENT: "EQP",
    "GENERAL EQUIPMENT": "EQP",
    "MEDICAL EQUIPMENT": "EQP",
    "OFFICE EQUIPMENT": "EQP",
    "EQUIPMENT (GENERAL/MEDICAL/OFFICE)": "EQP",
    SITE: "SITE",
    SITEWORKS: "SITE",
    "SITE WORK": "SITE",
    "SITE WORKS": "SITE",
    INFR: "INFR",
    INFRASTRUCTURE: "INFR",
    BRIDGE: "INFR",
    BRIDGES: "INFR",
    "PEDESTRIAN BRIDGE": "INFR",
    "PEDESTRIAN BRIDGES": "INFR",
};

export const ASSET_PHOTO_TYPE_OPTIONS = [
    "FRONT_VIEW",
    "BACK_VIEW",
    "LEFT_SIDE",
    "RIGHT_SIDE",
    "INTERIOR",
    "AERIAL",
    "BOUNDARY_WALL",
    "ROOF",
    "COMPOUND",
    "GARAGE",
    "OTHER",
];

export const CATEGORY_CODES_WITH_POST_PHOTO_TAB = new Set(["BLDG", "LAND"]);

export const BUILDING_EDIT_STEPS = [
    { key: "asset-info", label: "2.1 Asset Info" },
    { key: "security-overview", label: "2.1.1 Security Overview" },
    { key: "buildings", label: "2.1.2 Buildings" },
    { key: "site-works", label: "2.1.3 Site Works" },
];

export const SITE_WORK_TYPE_OPTIONS = [
    { value: "TANK_TOWER", label: "Tank Tower" },
    { value: "WATER_WELL", label: "Water Well" },
    { value: "GARDEN", label: "Garden" },
    { value: "SEPTIC_TANK", label: "Septic Tank" },
    { value: "WALK_WAYS", label: "Walk Ways" },
    { value: "PAVEMENT", label: "Pavement" },
    { value: "GATES", label: "Gates" },
    { value: "WALL_FENCE", label: "Wall Fence" },
    { value: "OTHERS", label: "Others (Specify)" },
];

export const INCOME_LEVEL_OPTIONS = [
    "Low Income",
    "Lower-Middle Income",
    "Middle Income",
    "Upper-Middle Income",
    "High Income",
    "Other",
];

export const ROAD_TYPE_OPTIONS = [
    "Tarmac",
    "Gravel",
    "Earth",
    "Stone",
    "Other",
];

export const BUILDING_USE_STATUS_OPTIONS = [
    { value: "OCCUPIED", label: "Occupied (Inakaliwa)" },
    { value: "UNOCCUPIED", label: "Unoccupied (Haikaliwi)" },
];

export const YEAR_OPTIONS = (() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= 1900; y -= 1) {
        years.push(String(y));
    }
    return years;
})();

export const ROOF_OPTIONS = [
    { code: "NIL", name: "Hakuna/Nil" },
    { code: "THATCHED", name: "Nyasi/Thatched" },
    { code: "IRON_SHEET", name: "Bati/Iron sheet" },
    { code: "TARPAULIN", name: "Turubai/Tarpaulin" },
    { code: "ALUMINUM_SHEETS", name: "Bati aluminium/Aluminium sheets" },
    { code: "MULTI_PITCHED", name: "Multi pitched" },
    { code: "MONO_PITCHED", name: "Mono pitched" },
    { code: "OTHERS", name: "Nyingine/Others" },
];

export const CEILING_OPTIONS = [
    { code: "NIL", name: "Hakuna/Nil" },
    { code: "CHIPBOARD", name: "Chipboard" },
    { code: "GYPSUM", name: "Gypsum" },
    { code: "TONGUED_AND_GROOVED_TIMBER", name: "Mbao / Tongued and Grooved Timber" },
    { code: "OTHERS", name: "Nyingine / Other" },
];

export const WALL_OPTIONS = [
    { code: "SAND_CEMENT_BLOCKS", name: "Tofali za mchanga na saruji / Sand cement blocks" },
    { code: "BURNT_BRICKS", name: "Tofali za kuchoma / Burnt bricks" },
    { code: "UNBURNT_BRICKS", name: "Tofali za tope / Unburnt bricks" },
    { code: "SAWN_TIMBER", name: "Mbanzi / Sawn timber" },
    { code: "WATTLE_AND_DAUB", name: "Udongo na fito / Wattle and daub" },
    { code: "STICKS_AND_GRASSES", name: "Fito na nyasi / Sticks and grasses" },
    { code: "TARPAULIN_AND_STICKS", name: "Turuba na fito / Tarpaulin and sticks" },
    { code: "STONES", name: "Mawe / Stones" },
    { code: "PLASTERED", name: "Enye lipu / Plastered" },
    { code: "PAINTED", name: "Enye rangi / Painted" },
    { code: "DWARF", name: "Fupi / Dwarf" },
    { code: "OTHERS", name: "Nyingine / Others" },
];

export const WINDOW_OPTIONS = [
    { code: "WOODEN_FRAMES", name: "Fremu za Mbao / Wooden Frames" },
    { code: "IRON_BARS", name: "Nondo / Iron Bars" },
    { code: "INSECT_SCREEN", name: "Nyawo / Insect screen" },
    { code: "WOODEN_CASEMENTS", name: "Wooden casements" },
    { code: "GRILLS", name: "Grills" },
    { code: "OPEN", name: "Wazi / Open" },
    { code: "NIL", name: "Hakuna / Nil" },
    { code: "GLAZED_ALUMINIUM_FRAMES", name: "Vioo na Fremu za aluminium / Glazed aluminium frames" },
    { code: "POLYPROPYLENE_WOVEN_SHEET_AND_STICKS", name: "Polypropylene woven sheet & sticks / Saifeti na fito" },
    { code: "BATTENED_CORRUGATED_IRON_SHEET", name: "Bati / Battened corrugated iron sheet" },
    { code: "OTHERS", name: "Nyingine / Others" },
];

export const DOOR_OPTIONS = [
    { code: "WOODEN_FRAMES", name: "Fremu za Mbao / Wooden Frames" },
    { code: "WOODEN", name: "Mbao / Wooden" },
    { code: "GRILLS", name: "Grills" },
    { code: "CORRUGATED_IRON_SHEET", name: "Bati / Corrugated iron sheet" },
    { code: "POLYPROPYLENE_WOVEN_SHEET", name: "Polypropylene woven sheet / Salfeti" },
    { code: "TARPAULIN", name: "Turubai / Tarpaulin" },
    { code: "BATTENED_TYPE", name: "Battened type" },
    { code: "PANEL_TYPE", name: "Panel type" },
    { code: "NIL", name: "Hakuna / Nil" },
    { code: "OTHERS", name: "Nyingine / Others" },
];

export const FLOOR_OPTIONS = [
    { code: "SAND_CEMENT_SCREED", name: "Saruji na Mchanga / Sand cement screed" },
    { code: "EARTH", name: "Udongo / Earth" },
    { code: "TILES", name: "Vigae / Tiles" },
    { code: "TERRAZZO", name: "Terrazzo" },
    { code: "ROUGH_CONCRETE", name: "Zege / Rough concrete" },
    { code: "OTHERS", name: "Nyingine / Others" },
];

export const ACCOMMODATION_TYPE_OPTIONS = [
    "Bedrooms",
    "Master Bedroom",
    "Sitting Room",
    "Dining Room",
    "Kitchen",
    "Store / Pantry",
    "Bathroom",
    "Toilet",
    "Corridor / Passage",
    "Veranda / Balcony",
    "Laundry Area",
    "Garage",
    "Servant Quarter / DSQ",
    "Classrooms",
    "Laboratories",
    "Computer Lab",
    "Library",
    "Dormitory",
    "Dining Hall",
    "Office",
    "Staff Room",
    "Sickbay / Clinic",
    "Kitchen (Institutional)",
    "Toilets / Washrooms",
    "Utility Room",
    "Preparation Room",
    "Reception Area",
    "Open Office Space",
    "Meeting Room",
    "Executive Office",
    "Records / Archive Room",
    "Server / IT Room",
    "Kitchenette",
    "Store Room",
    "Strong Room / Safe Room",
    "Workshop Area",
    "Sales Room / Showroom",
    "Guest Room",
    "Suite",
    "Restaurant",
    "Bar / Lounge",
    "Conference Room",
    "Laundry Room",
    "Cold Storage",
    "Housekeeping Room",
    "Workshop",
    "Machinery Room",
    "Control Room",
    "Warehouse / Store",
    "Loading Bay",
    "Power House",
    "Generator Room",
    "Pump Room",
    "Guard House",
    "Changing Room",
    "Rest Area",
    "Staircase",
    "Lift Lobby",
    "Balcony / Terrace",
    "Roof Tank Area",
    "Septic / Water Tank Room",
    "OTHERS",
];
